import common from './common'

const white = {
  ...common.button,
  color: `omegaDark`,
  bg: `omegaLighter`,
  borderColor: `omega`,
  borderWidth: `md`,
  borderStyle: `solid`,
  ':hover': {
    borderColor: `alpha`,
  },
}

export default white